/* Carrito lateral (Klayful):
   1) Botón "Añadir" de las sugerencias.
   2) Claridad antes de pagar: envío (gratis disponible / exprés) y pago seguro, justo encima y debajo del botón.
   3) Movimiento: entrada escalonada, subtotal que destaca, brillo en el botón de pagar. Respeta "reducir movimiento". */
(function () {
  if (window.__cartUpsellBound) return;
  window.__cartUpsellBound = true;

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('.cart-upsell__add');
    if (!btn) return;
    evt.preventDefault();

    var select = btn.closest('.cart-upsell__item').querySelector('.cart-upsell__variant');
    var id = select ? select.value : btn.getAttribute('data-upsell-variant');
    var form = btn.closest('cart-form');
    btn.disabled = true;

    fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function () {
        if (form && typeof form.refresh === 'function') form.refresh();
        else window.location.reload();
      })
      .catch(function () {
        btn.disabled = false;
      });
  });

  try {
    var D = 'cart-drawer ';
    var K = 'cart-drawer.kc-run ';
    var F = 'cart-drawer.kc-flash ';
    var css =
      D + '.cart-upsell{margin:14px 0;padding:16px;border:1px solid #bbccca!important;border-radius:18px;background:#f4f7f6}' +
      D + '.cart-upsell__title{font-size:1.05em;margin-bottom:12px}' +
      D + '.cart-upsell__item{padding:10px;border-radius:14px;background:#fff;border:1px solid rgba(187,204,202,.6);transition:transform .35s cubic-bezier(.2,.8,.2,1),box-shadow .35s ease}' +
      D + '.cart-upsell__img{border-radius:12px;transition:transform .5s cubic-bezier(.2,.8,.2,1)}' +
      D + '.cart-upsell__add{border-radius:999px;transition:transform .25s ease,box-shadow .25s ease}' +
      '@media (hover:hover){' + D + '.cart-upsell__item:hover{transform:translateY(-2px);box-shadow:0 10px 22px rgba(23,62,56,.14)}' + D + '.cart-upsell__item:hover .cart-upsell__img{transform:scale(1.06)}' + D + '.cart-upsell__add:hover{transform:translateY(-1px);box-shadow:0 6px 14px rgba(23,62,56,.2)}}' +
      D + '.cart-drawer__footer .subtotal{padding:12px 16px;border-radius:14px;background:#f4f7f6;border:1px solid #bbccca;transition:background .4s ease,box-shadow .4s ease}' +
      D + '.kc-ship{display:flex;align-items:flex-start;gap:10px;margin:0 0 12px;padding:10px 14px;border-radius:14px;background:#f4f7f6;border:1px solid #bbccca;font-size:13px;line-height:1.4;color:#173e38}' +
      D + '.kc-ship svg{flex:none;width:20px;height:20px;margin-top:1px}' +
      D + '.kc-trust{display:flex;align-items:center;justify-content:center;gap:8px;margin:12px 0 0;font-size:12.5px;line-height:1.4;color:#173e38;text-align:center}' +
      D + '.kc-trust svg{flex:none;width:16px;height:16px}' +
      D + '.checkout-buttons .btn{position:relative;overflow:hidden;border-radius:999px;transition:transform .25s ease,box-shadow .25s ease}' +
      D + '.checkout-buttons .btn::after{content:"";position:absolute;top:0;bottom:0;left:0;width:40%;background:linear-gradient(110deg,transparent,rgba(255,255,255,.35),transparent);transform:translateX(-140%);pointer-events:none}' +
      '@media (hover:hover){' + D + '.checkout-buttons .btn:hover{transform:translateY(-2px);box-shadow:0 12px 24px rgba(23,62,56,.28)}}' +
      '@keyframes kc-slide{from{opacity:0;transform:translateX(26px)}to{opacity:1;transform:none}}' +
      '@keyframes kc-rise{from{opacity:0;transform:translateY(18px)}to{opacity:1;transform:none}}' +
      '@keyframes kc-bump{0%{transform:scale(1)}35%{transform:scale(1.35)}100%{transform:scale(1)}}' +
      '@keyframes kc-flash{0%{box-shadow:0 0 0 0 rgba(187,204,202,.9);background:#e3ebe9}100%{box-shadow:0 0 0 16px rgba(187,204,202,0);background:#f4f7f6}}' +
      '@keyframes kc-sweep{0%,60%{transform:translateX(-140%)}100%{transform:translateX(360%)}}' +
      '@keyframes kc-pulse{0%{box-shadow:0 0 0 0 rgba(23,62,56,.35)}70%,100%{box-shadow:0 0 0 10px rgba(23,62,56,0)}}' +
      '@media (prefers-reduced-motion:no-preference){' +
        K + '[data-merge-list-item]{animation:kc-slide .6s cubic-bezier(.2,.8,.2,1) both}' +
        K + '[data-merge-list-item]:nth-child(1){animation-delay:.12s}' +
        K + '[data-merge-list-item]:nth-child(2){animation-delay:.22s}' +
        K + '[data-merge-list-item]:nth-child(3){animation-delay:.32s}' +
        K + '[data-merge-list-item]:nth-child(n+4){animation-delay:.4s}' +
        K + '.cart-upsell{animation:kc-rise .65s cubic-bezier(.2,.8,.2,1) .35s both}' +
        K + '.cart-upsell__item{animation:kc-rise .6s cubic-bezier(.2,.8,.2,1) both}' +
        K + '.cart-upsell__item:nth-child(1){animation-delay:.5s}' +
        K + '.cart-upsell__item:nth-child(2){animation-delay:.62s}' +
        K + '.cart-upsell__item:nth-child(3){animation-delay:.74s}' +
        K + '.cart-drawer__title-count{display:inline-block;animation:kc-bump .6s cubic-bezier(.3,1.6,.5,1) .3s both}' +
        K + '.cart-drawer__footer .subtotal{animation:kc-rise .6s cubic-bezier(.2,.8,.2,1) .45s both}' +
        K + '.kc-ship{animation:kc-rise .6s cubic-bezier(.2,.8,.2,1) .5s both}' +
        K + '.checkout-buttons .btn{animation:kc-rise .6s cubic-bezier(.2,.8,.2,1) .55s both}' +
        D + '.checkout-buttons .btn::after{animation:kc-sweep 5.5s ease-in-out 2.5s infinite}' +
        D + '.cart-upsell__add{animation:kc-pulse 2.8s ease-out 1.2s infinite}' +
        D + '.cart-upsell__add[disabled]{animation:none}' +
        F + '.subtotal{animation:kc-flash .9s ease-out!important}' +
      '}';
    if (!document.getElementById('kc-cart-css')) {
      var st = document.createElement('style');
      st.id = 'kc-cart-css';
      st.textContent = css;
      document.head.appendChild(st);
    }

    var TRUCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 7h11v9H3z"/><path d="M14 10h4l3 3v3h-7z"/><circle cx="7" cy="17" r="1.6"/><circle cx="17" cy="17" r="1.6"/></svg>';
    var LOCK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';

    /* Textos por idioma (el idioma principal de la tienda, "en", lleva el texto en español) */
    var LANG = (document.documentElement.lang || 'es').slice(0, 2);
    var NOTES = {
      de: {
        ship: 'Inkl. MwSt. Versand 8,90 €, <strong>kostenlos ab 120 €</strong>. Die Versandart wählst du im nächsten Schritt, vor der Zahlung.',
        trust: 'Zahlung 100 % sicher · Karte, PayPal, Apple Pay und Google Pay'
      },
      it: {
        ship: 'Tasse incluse. Spedizione 8,90 €, <strong>gratuita da 89 €</strong>. Sceglierai la spedizione al passaggio successivo, prima di pagare.',
        trust: 'Pagamento 100 % sicuro · Carta, PayPal, Apple Pay e Google Pay'
      },
      es: {
        shipEs: '<strong>Envío gratis disponible</strong> (3-5 días laborables) o exprés en 24-48 h por 6,90 €. Impuestos incluidos.',
        ship: 'Impuestos incluidos. Elegirás el envío en el siguiente paso, antes de pagar.',
        trust: 'Pago 100 % seguro · Tarjeta, PayPal, Apple Pay y Google Pay'
      }
    };

    /* Aviso de envío y de pago seguro, encima y debajo del botón de pagar */
    function ensureNotes(drawer) {
      var btns = drawer.querySelector('.checkout-buttons');
      if (!btns) return;
      var country = (window.Shopify && window.Shopify.country) || '';
      var N = NOTES[LANG] || NOTES.es;
      var shipText = (!NOTES[LANG] && country === 'ES') ? NOTES.es.shipEs : N.ship;
      if (!drawer.querySelector('.kc-ship')) {
        var ship = document.createElement('div');
        ship.className = 'kc-ship';
        ship.innerHTML = TRUCK + '<span>' + shipText + '</span>';
        btns.parentNode.insertBefore(ship, btns);
      }
      if (!drawer.querySelector('.kc-trust')) {
        var tr = document.createElement('div');
        tr.className = 'kc-trust';
        tr.innerHTML = LOCK + '<span>' + N.trust + '</span>';
        btns.parentNode.insertBefore(tr, btns.nextSibling);
      }
    }

    function watch(drawer) {
      if (drawer.__kcWatch) return;
      drawer.__kcWatch = true;
      var run = function () {
        ensureNotes(drawer);
        drawer.classList.remove('kc-run');
        void drawer.offsetWidth;
        drawer.classList.add('kc-run');
      };
      ensureNotes(drawer);
      if (drawer.getAttribute('aria-hidden') === 'false') run();
      new MutationObserver(function () {
        if (drawer.getAttribute('aria-hidden') === 'false') run();
      }).observe(drawer, { attributes: true, attributeFilter: ['aria-hidden'] });

      var footer = drawer.querySelector('[data-merge="footer"]');
      if (footer) {
        var t;
        new MutationObserver(function () {
          ensureNotes(drawer);
          drawer.classList.add('kc-flash');
          clearTimeout(t);
          t = setTimeout(function () { drawer.classList.remove('kc-flash'); }, 1000);
        }).observe(footer, { childList: true, subtree: true, characterData: true });
      }
    }
    function init() {
      var d = document.querySelector('cart-drawer');
      if (d) watch(d);
    }
    init();
    document.addEventListener('DOMContentLoaded', init);
  } catch (e) { /* sin extras */ }
})();
